import { useContext } from 'react'

import { FieldVariableContext } from '../../FieldVariable.context'

export function useFieldVariableContext() {
  return useContext(FieldVariableContext)
}
